<script>
import firebase from "firebase";

export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    async apiNearbyInfo(payload) {
      // console.log("apiNearbyInfo", payload)
      let nearbyObj = [];
      const nearByRef = firebase
        .firestore()
        .collection("properties")
        .doc(payload.id)
        .collection(payload.type);

      return await nearByRef
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let nearby = doc.data();
            // console.log(`got ${payload.type}`, nearby)
            nearbyObj.push(nearby);
          });
          return nearbyObj;
        })
        .then((nearbyObj) => {
          // console.log("nearbyObj", nearbyObj)
          return nearbyObj;
        });
      // if (doc.exists) {
      //     let nearby = doc.data()
      //     console.log("got nearby", nearby)
      //     return nearby
      // } else {
      //     console.log("nearby does not exist")
      // }
    },
    async apiGetUser(id) {
      // console.log("apiGetUser", id)
      const userRef = firebase.firestore().collection("users").doc(id);
      return await userRef.get().then((doc) => {
        if (doc.exists) {
          let user = doc.data();
          // console.log("got user", user)
          return user;
        } else {
          console.log("user does not exist");
        }
      });
    },
    async apiUpdateUser(id, payload) {
      // console.log("apiUpdateUser", id, payload)
      const userRef = firebase.firestore().collection("users").doc(id);

      return await userRef.update(payload).then((resp) => {
        // console.log('apiUpdateUser success!', resp)
        return true;
      });
    },
    updatePageGroup(propID, groupName) {
      const propRef = firebase
        .firestore()
        .collection("properties")
        .doc(id)
        .collection("groupName")
        .doc("subsections");
    },
    async apiUpdateProperty(id, payload) {
      // console.log("apiUpdateProperty", id, payload)
      const propRef = firebase.firestore().collection("properties").doc(id);

      return await propRef.update(payload).then((resp) => {
        // console.log("apiUpdateProperty success", resp)
        return true;
      });
    },

    async apiGetNearbyDirect(payload) {
      let nearbyDirect = [];
      let defaultData = {
        location: "33.7489954,-84.3879824",
        radius: 1000,
        keyword: "Food + Drink",
        useTestData: true,
      };
      let data = payload || defaultData;
      
      // Debug logging for nearby places
      console.log("apiGetNearbyDirect payload:", data);
      
      if (!data.location || data.location === "undefined,undefined" || data.location === "null,null") {
        console.error("Invalid location coordinates:", data.location);
        return [];
      }
      
      let getNearby = firebase.functions().httpsCallable("getNearbyDirect");
      return await getNearby(data)
        .then((res) => {
          nearbyDirect = res.data.result;
          console.log("apiGetNearbyDirect results count:", nearbyDirect ? nearbyDirect.length : 0);
          console.log("apiGetNearbyDirect sample result:", nearbyDirect?.[0]);
          return nearbyDirect;
        })
        .catch((error) => {
          console.error("apiGetNearbyDirect error:", error);
          return [];
        });
    },

    async apiGetDistanceMatrix(payload) {
      // OPTIMIZATION: Add request deduplication to prevent multiple identical calls (ROLLBACK: remove deduplication logic)
      const requestKey = `${payload.origins}_${payload.destinations}`;
      if (
        this.pendingDistanceRequests &&
        this.pendingDistanceRequests[requestKey]
      ) {
        console.log("Deduplicating distance matrix request for:", requestKey);
        return this.pendingDistanceRequests[requestKey];
      }

      if (!this.pendingDistanceRequests) {
        this.pendingDistanceRequests = {};
      }

      console.log("getDistanceMatrix", payload);
      let getDistanceOnCall = firebase
        .functions()
        .httpsCallable("getDistanceOnCall");

      const promise = getDistanceOnCall(payload)
        .then((res) => {
          console.log("apiGetDistanceMatrix res ", res);
          let matrix = res.data.result.rows[0].elements;
          console.log("apiGetDistanceMatrix in api ", matrix);
          delete this.pendingDistanceRequests[requestKey]; // Clean up
          return matrix;
        })
        .catch((error) => {
          console.log("apiGetDistanceMatrix error ", error);
          delete this.pendingDistanceRequests[requestKey]; // Clean up
        });

      this.pendingDistanceRequests[requestKey] = promise;
      return promise;
    },

    async apiRemoveFromStorage(storageUrl) {
      const path = decodeURIComponent(storageUrl.match(/\/o\/(.*)\?alt/)[1]);
      let storageRef = firebase.storage().ref();
      let imageRef = storageRef.child(path);
      return await imageRef
        .delete()
        .then((res) => {
          // console.log("removeFromStorage success", res)
          return true;
        })
        .catch((error) => {
          console.log("removeFromStorage error", error);
        });
    },

    async apiLogGuestVisit(propertyId) {
      const today = new Date().toISOString().split("T")[0];
      const storageKey = `EHVisit_${propertyId}_${today}`;

      if (localStorage.getItem(storageKey)) {
        return;
      }

      try {
        const logGuestVisit = firebase.functions().httpsCallable("logGuestVisit");
        await logGuestVisit({ propertyId });
        localStorage.setItem(storageKey, "logged");
      } catch (error) {
        console.error("Error saving guest visit log:", error);
      }
    },

    async apiGetAppSettings() {
      //console.log("apiGetAppSettings")

      await this.apiGetDoc("settings", "globalAppSettings").then((data) => {
        //console.log("commit app settings", data)

        this.$store.commit("setAppSettings", data);
      });
    },

    //GENERIC get and update doc by ID
    async apiGetDoc(collection, docID) {
      // console.log("apiGetDoc", collection, docID);

      const docRef = firebase.firestore().collection(collection).doc(docID);
      return await docRef.get().then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          // console.log("got doc", data)
          return data;
        } else {
          console.log("data doesn't exist");
        }
      });
    },
    async apiUpdateDoc(collection, docID, payload) {
      // console.log("apiUpdateDoc", collection, docID, payload)

      const docRef = firebase.firestore().collection(collection).doc(docID);

      return await docRef.update(payload).then((resp) => {
        //console.log("updated", resp)
        return true;
      });
    },

    // Custom URL Functions
    async apiCreateCustomUrl(customString, propertyId) {
      const createVanity = firebase
        .functions()
        .httpsCallable("createVanityUrl");
      return await createVanity({ vanityString: customString, propertyId });
    },

    async apiGetCustomUrlsForProperty(propertyId) {
      const getVanityUrls = firebase
        .functions()
        .httpsCallable("getVanityUrlsForProperty");
      return await getVanityUrls({ propertyId });
    },

    async apiDeactivateCustomUrl(customUrlId) {
      const deactivateVanity = firebase
        .functions()
        .httpsCallable("deactivateVanityUrl");
      return await deactivateVanity({ vanityUrlId: customUrlId });
    },
  },
  computed: {},
};
</script>
